import axios from '../axios.jsx';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import EvaluacionRiesgo from './EvaluacionRiesgo.jsx';


const URI = 'sat/';
const URI2 = 'fuente/';

const CompEditBlog = () => {
  const [fechaIngreso, setFechaIngreso] = useState('');
  const [semanaepi, setsemanaepi] = useState('');
  const [municipio, setmunicipio] = useState('');
  const [fuentes, setfuentes2] = useState('');
  const [codigoSat, setCodigoSat] = useState('');
  const [eventos, seteventos] = useState('');
  const [eventos2, seteventos2] = useState([]);
  const [titulo, settitulo] = useState('');
  const [resumen, setresumen] = useState('');
  const [fuente, setfuente] = useState([]);
  const [gestor, setgestor] = useState('');
  const [mostrarEvaluacion, setMostrarEvaluacion] = useState(false);
  const [evaluacion, setEvaluacion] = useState('');
  const [nivel, setNivel] = useState('');
  const [respuesta, setRespuesta] = useState('');

  const navigate = useNavigate();
  const { id } = useParams()
  const isSen = codigoSat.startsWith('SEN');

  const store = async (e) => {
    e.preventDefault();
    await axios.put(URI+id, {
      createAt: fechaIngreso,
      Fecha_identificacion: fechaIngreso,
      Codigo: codigoSat,
      Titulo: titulo,
      Semana_epi: semanaepi,
      Gestor: gestor,
      Fuente: fuentes,
      Departamento: 'Amazonas',
      Municipio: municipio,
      Resumen: resumen,
      Evento: eventos,
      Respuesta: respuesta,
      Puntaje: evaluacion,
      Nivel_Riesgo: nivel,
    });
    navigate('/app');
  };

  useEffect(() => {
 
    getBlogById();
    geteventoById();


  }, []);

  




  const getBlogById = async () => {
      const res = await axios.get(URI + id)
      const iso = res.data.Fecha_identificacion;
  const dateOnly = iso ? iso.split('T')[0] : '';
  setFechaIngreso(dateOnly);
      setsemanaepi(res.data.Semana_epi)
      settitulo(res.data.Titulo)
      setresumen(res.data.Resumen)
      setCodigoSat(res.data.Codigo)
      
      setmunicipio(res.data.Municipio)
      setfuentes2(res.data.Fuente)
      seteventos(res.data.Evento)
      setEvaluacion(res.data.Puntaje)
      setNivel(res.data.Nivel_Riesgo)
      setRespuesta(res.data.Respuesta)
      setgestor(res.data.Gestor)
      try {
            const res = await axios.get(URI2);
            setfuente(res.data);
          } catch (error) {
            console.error('Error al obtener fuentes:', error);
          }
    }

  const evaluarRiesgo = () => {
    setMostrarEvaluacion(true);
  };

  const onResultadosListos = ({ evaluacion, nivel, respuesta }) => {
    setEvaluacion(evaluacion);
    setNivel(nivel);
    setRespuesta(respuesta);
    setMostrarEvaluacion(false);
  };

 
  const geteventoById = async () => {
    try {
      const res = await axios.get('/eventos');
      seteventos2(res.data);
    } catch (error) {
      console.error('Error al obtener eventos:', error);
    }
  };



  return (
    <div className="container">
      <h2 className="text-center mb-5 mt-3">FORMULARIO SISTEMA DE ALERTA TEMPRANA</h2>
      <form onSubmit={store}>
        <div className="row">
          <div className="col-md-6">
            {/* Campos lado izquierdo */}
            {/* ...[campos existentes]... */}
            <label className="mb-1">Codigo SAT</label>
            <input type="text" className="form-control mb-2" value={codigoSat} readOnly />
            <label className="mb-1">Fecha de ingreso</label>
<input
  type="date"
  className="form-control mb-2"
  value={fechaIngreso}
  readOnly
/>
            <label className="mb-1">Semana epidemiologica</label>
            <input type="text" className="form-control mb-2" value={semanaepi} onChange={(e) => setsemanaepi(e.target.value)} required />
            <label className="mb-1">Gestor SAT</label>
            <input type="text" className="form-control mb-2" value={gestor} readOnly />
            <label className="mb-1">Municipio</label>
              <select
                className="form-control mb-2"
                value={municipio}
                onChange={(e) => setmunicipio(e.target.value)}
                required
              >
                <option value="">Selecciona una opcion</option>
                <option value="LETICIA">LETICIA</option>
                <option value="PUERTO NARIÑO">PUERTO NARIÑO</option>
                <option value="ENCANTO">ENCANTO</option>
                <option value="CHORRERA">CHORRERA</option>
                <option value="PEDRERA">PEDRERA</option>
                <option value="LA VICTORIA">LA VICTORIA</option>
                <option value="MIRITI-PARANA">MIRITI-PARANA</option>
                <option value="PUERTO ALEGRIA">PUERTO ALEGRIA</option>
                <option value="PUERTO ARICA">PUERTO ARICA</option>
                <option value="PUERTO SANTANDER">PUERTO SANTANDER</option>
                <option value="TARAPACA">TARAPACA</option>
              </select>
            <label className="mb-1">Fuente</label>
            <select className="form-control mb-2" value={fuentes} onChange={(e) => setfuentes2(e.target.value)} required>
              <option value="">Selecciona una opción</option>
              {fuente.map(option => <option key={option.id} value={option.nombre}>{option.nombre}</option>)}
            </select>
            <label className="mb-1">Evento</label>
            <select className="form-control mb-2" value={eventos} onChange={(e) => seteventos(e.target.value)} required>
              <option value="">Selecciona una opción</option>
              {eventos2.map(option => <option key={option.id} value={option.nombre}>{option.nombre}</option>)}
            </select>
          </div>

          <div className="col-md-6">
            {/* Campos lado derecho */}
            <label>Título</label>
            <textarea className="form-control mb-2" value={titulo} onChange={(e) => settitulo(e.target.value.toUpperCase())} required />
            <label>Resumen</label> 
            <textarea
            className="form-control mb-2"
            style={{ height: '200px', resize: 'vertical' }}
            value={resumen}
           onChange={(e) => setresumen(e.target.value)}
           required
            />

            <div className="row g-3">
              <div className="col-md-6">
                <label>Evaluación del riesgo</label>
                <input className="form-control" value={evaluacion} readOnly />
              </div>
              <div className="col-md-6">
                <label>Nivel del riesgo</label>
                <input type="text" className="form-control" value={nivel} readOnly />
              </div>
            </div>
            <label className="mt-2">Respuesta</label>
            <input type="text" className="form-control mb-3" value={respuesta} readOnly />

            <div className="text-center">
              <button type="button" className="btn btn-primary" onClick={evaluarRiesgo} disabled={isSen}>
                Evaluar Riesgo
              </button>
              

            </div>
          </div>
        </div>

        <div className="form-group text-center mt-4">
           <button type="button" className="btn btn-secondary " onClick={() => navigate(-1)}>
    Volver
  </button>
          <button type="submit" className="btn btn-success ms-1">
            Enviar
          </button>
        </div>
      </form>

      {mostrarEvaluacion && (
        <EvaluacionRiesgo onClose={() => setMostrarEvaluacion(false)} onResultadosListos={onResultadosListos} />
      )}
    </div>
  );
};

export default CompEditBlog;
